import React from 'react'
import Comment from './Comment'
import styled from 'styled-components'
import * as vars from '../variables.js'
import { maxColWidth } from '../variables'

const Container = styled.div`
  align-self: flex-start;
  background-color: ${vars.backgroundColor};
  border: 1px solid ${vars.gray};
  border-radius: 2px;
  box-shadow: 1px 1px 3px ${vars.lightGray};
  flex: 1 1 400px;
  margin-left: 15px;
  max-height: calc(100vh - ${vars.verticalSpace}px);
  max-width: ${maxColWidth}px;
  position: sticky;
  top: ${vars.bannerHeight + vars.gutterSize}px;
  padding: 0 10px;
  overflow-y: auto;
`

const Title = styled.h2`
  border-bottom: 1px solid ${vars.lightGray};
  color: ${vars.textColor};
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
  margin: 15px 0 15px;

  a {
    color: ${vars.blue};
    cursor: pointer;
    text-decoration: none;
    transition: color 0.3s;

    :hover {
      color: ${vars.lightBlue};
    }
  }
`

const P = styled.p`
  line-height: 1.2;
  text-align: justify;
  margin: 0 0 10px;
`

const Exit = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 1.2rem;
  margin: 0 0 10px;

  p {
    margin: 0;
  }

  svg {
    transition: all 0.3s;
  }

  :hover svg {
    cursor: pointer;
    color: ${vars.lightBlue};
    transform: scale(1.1);
  }
`

export default class Column extends React.Component {
  // https://en.wikipedia.org/wiki/English_numerals#Ordinal_numbers
  getOrdinalSuffix = n => ['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th'

  render() {
    // display information about a particular issue
    if (this.props.info) {
      return (
        <Container>
          <Title>
            Description
            <a
              href={`https://jira.illum.io/browse/${this.props.info.issueId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {this.props.info.issueId}
            </a>
          </Title>
          <Exit>
            <p>
              {Number.isInteger(this.props.rank)
                ? `Ranked ${this.props.rank + 1}${this.getOrdinalSuffix(this.props.rank + 1)}`
                : 'Unranked'}
            </p>
          </Exit>
          {this.props.info.description?.split('\r\n').map((str, idx) => {
            if (str.charAt(0) === '*') {
              return <P key={idx}>{`• ${str.slice(1)}`}</P>
            }

            return <P key={idx}>{str}</P>
          })}
          <Comment comments={this.props.info.comments} />
        </Container>
      )
    }

    // default placeholder
    return (
      <Container>
        <Title>Instructions</Title>
        <P>Hello! Welcome to the UX Rankings page!</P>
        <P>
          These are all your own personal rankings! The ranked column is ranked in descending order, meaning the higher
          up the issue, the more important it is to you!
        </P>
        <P>
          Data will be collected from many people in the company, and it will help the UXD team do their jobs much more
          efficiently.
        </P>
        <P>Try it out! It's as simple as dragging one of the issues to either the ranked or unranked column.</P>
        <P>
          If you need more information about a particular issue, click on the card and information will be displayed in
          the right most column!
        </P>
      </Container>
    )
  }
}
